import { Button, TextField, Typography } from "@mui/material";
import '../styles/Home.css';
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useRest } from "react-common";

const Home = () => {

    const { t } = useTranslation();
    const [groupCode, setGroupCode] = useState();
    const navigate = useNavigate();
    const { getData } = useRest();
    const [errorMessage, setErrorMessage] = useState("")

    const joinPresentation = () => {
        if (!groupCode) {
            setErrorMessage(t("errorMessage.emptyCode"))
        } else {
            getData("Presentation/" + groupCode)
                .then((presentation) => {
                    navigate(`/presentation/${presentation.id}`)
                })
                .catch(err => setErrorMessage(t("errorMessage.invalidCode")))
        }
    }

    return (
        <div className="homeContainer">
            <div className="homeGroupButtons">
                <div className="joinContainer">
                    <Typography className="enterCodeLabel" variant="h5">{t('enterCode')}</Typography>
                    <TextField 
                        error={errorMessage.length > 0} 
                        helperText={errorMessage ? errorMessage : ""}
                        onChange={(event) => {setGroupCode(event.target.value); setErrorMessage("")}} 
                    />
                    <Button variant="contained" color="primary" onClick={joinPresentation}>{t("presentation.join")}</Button>
                </div>
                <div className="presenterContainer">
                    <Typography variant="body2" >{t("presentation.isPresenter")}</Typography>
                    <Link to={`/presentation`}>
                        <Button color="primary" >{t("presentation.present")}</Button>
                    </Link>
                </div>
                <div className="editorContainer">
                    <Link to={`/editor`}>
                        <Button variant="outlined" color="primary" >{t("presentation.manage")}</Button>
                    </Link >
                </div>
            </div>
        </div>
    )
}

export default Home;